import React, { useEffect, useState, useRef } from "react";
import "./Center.css";
// import "../NavBar/NavBar.css";

import Video from "../../Images/video-small.png";
import Camera from "../../Images/camera-small.png";

import Documents from "../../Images/Documents.png";
import Sundanse from "../../Images/Sundanse.png";
import POC4 from "../../Images/POC4ver2.png";
import ENOTTA from "../../Images/ENOTTA 2.png";
import StartEngine from "../../Images/StartEngine.png";
import StartingBloch from "../../Images/StartingBloch.png";
import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
//import photoRef from "../../Images/photoURL.png";
import {
  collection,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { app } from "../lib/firebase";
import PostList from "./components/PostList";
import { createPost, uploadMedia } from "./actions/index";
import { NewGroupProfileType } from "../Types/groupProfile";
import { NewUserProfileType } from "../Types/userProfile";
import { NewProjectProfileType } from "../Types/projectProfile";
import { NewProjectExperimentType } from "../Types/projectExperiment";
import RetrieveUserProfileById from "../UserProfile/RetrieveUserProfileById";
import CreatePostModal from "./components/PostModal";

var bodyStyles = document.body.style;
bodyStyles.setProperty("--about-display", "none");
const photoURL = localStorage.getItem("myPicture");
const currentUserId = localStorage.getItem("userUID");
console.log("in Center and userUID = ", currentUserId);
//Now to get the userProfile from firebase so we can extract the profile picture
//we need to pass the userUID to a function and get the userProfile in return
const photoRef = UpdateUserPhotoURL(photoURL);
console.log("in center after UpdateUserPhotoURL and photoURL = ", photoRef);
const handleAboutClick = (event: React.MouseEvent<HTMLElement>) => {
  console.log("Clicked about!");
  bodyStyles.setProperty("--about-display", "none");
};

function Center() {
  // const [groupProfiles, setGroupProfiles] = useState<NewGroupProfileType[]>([]);
  // const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  // const [projectProfiles, setProjectProfiles] = useState<
  // 		NewProjectProfileType[]
  // 	>([]);
  // 	const [projectExperiments, setProjectExperiments] = useState<
  // 		NewProjectExperimentType[]
  // 	>([]);

  const userName = localStorage.getItem("userName");

  //let currentUserId = tempUser;
  //if (tempUser) {
  //  currentUserId = tempUser;
  //} else {
  //  currentUserId = "1DqYAYvfb9MbXJnoq7hoX3efyXS2";
  //}

  const [groupProfiles, setGroupProfiles] = useState<
    { id: string; [key: string]: any }[]
  >([]);
  const [userProfiles, setUserProfiles] = useState<
    { id: string; [key: string]: any }[]
  >([]);
  const [projectProfiles, setProjectProfiles] = useState<
    { id: string; [key: string]: any }[]
  >([]);
  const [projectExperiments, setProjectExperiments] = useState<
    { id: string; [key: string]: any }[]
  >([]);

  const [showCountries, setShowCountries] = useState("Show");

  const [showPostModal, setShowPostModal] = useState(false);
  const [openCountriesList, setOpenCountriesList] = useState("none");

  //let openCountriesList = "none";

  let numberOfCountries = 0;
  let numberOfGroups = 0;
  let numberOfProjects = 0;
  let numberOfUsers = 0;
  let numberOfExperiments = 0;
  let numberOfRequests = 0;

  let countries: string[] = [];
  const db = getFirestore(app);

  //  const [projectExperiments, setProjectExperiments] = useState<
  //  { id: string; [key: string]: any }[]
  // >([]);

  let connectionMessage = "";
  const [connectionQuery, setConnectionQuery] = useState<
    { id: string; [key: string]: any }[]
  >([]);

  const [postContent, setPostContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<File | null>(null);
  const [selectedDocument, setSelectedDocument] = useState<File | null>(null);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const videoInputRef = useRef<HTMLInputElement>(null);
  const documentInputRef = useRef<HTMLInputElement>(null);

  const [currentUser, setCurrentUser] = useState({
    displayName: userName,
    email: "",
    photoURL: photoRef,
    createdAt: Date,
    updatedAt: Date,
  });

  //const [currentUser, setCurrentUser] = useState<{
  //  displayName: string;
  //  email: string;
  //  photoURL: string;
  //  createdAt: Date;
  //  updatedAt: Date;
  //} | null>();

  //useEffect(() => {
  //  async function fetchData() {
  //    const userProfile = await RetrieveUserProfileById(currentUserId);
  //    setCurrentUser(userProfile);
  //  }
  //  fetchData();
  //}, [currentUserId]);

  console.log("currentUser = ", currentUser);
  console.log("currentUserId = ", currentUserId);

  function ShowClick() {
    console.log("ShowClick entered");
    if (showCountries === "Show") {
      setShowCountries("Close");
      setOpenCountriesList("block");
      //openCountriesList = "none";
    } else {
      setShowCountries("Show");
      setOpenCountriesList("none");
      //openCountriesList = "block";
    }
  }

  const q0 = query(collection(db, "Groups"));
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  //console.log("groupProfiles.length = ", groupProfiles.length);
  numberOfGroups = groupProfiles.length;

  const q1 = query(collection(db, "userProfiles"));
  useEffect(
    () =>
      onSnapshot(q1, (snapshot) => {
        setUserProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfUsers = userProfiles.length;

  for (let i = 0; i < numberOfUsers; i++) {
    if (userProfiles[i].userCountry !== undefined) {
      countries.push(userProfiles[i].userCountry);
    }
  }
  console.log("countries = ", countries);
  let unSortedArray = countries.reduce(function (a: string[], b) {
    if (a.indexOf(b) < 0) a.push(b);
    return a;
  }, []);

  //let uniqueCountries = unSortedArray.sort((x, y) => x > y ? 1 : x < y ? -1 : 0)
  let uniqueCountries = unSortedArray.sort();

  //console.log("uniqueCountries = ", uniqueCountries);
  numberOfCountries = uniqueCountries.length;

  const q2 = query(collection(db, "projectProfiles"), orderBy("country"));
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfProjects = projectProfiles.length;

  const q3 = query(collection(db, "projectExperiments"));
  useEffect(
    () =>
      onSnapshot(q3, (snapshot) => {
        setProjectExperiments(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfExperiments = projectExperiments.length;

  const q4 = query(
    collection(db, "connectionRequests"),
    where("requestToEmail", "==", currentUserId)
  );
  useEffect(
    () =>
      onSnapshot(q4, (snapshot) => {
        setConnectionQuery(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfRequests = connectionQuery.length;
  if (numberOfRequests > 0) {
    connectionMessage =
      "You have a connection request! Select Connections and check it out...";
  }

  const handleCreatePost = async () => {
    if (
      !postContent.trim() &&
      !selectedImage &&
      !selectedVideo &&
      !selectedDocument
    ) {
      return;
    }

    setIsSubmitting(true);
    try {
      const uploadPromises: Promise<string>[] = [];
      let imageUrl: string | undefined = undefined,
        videoUrl: string | undefined = undefined;

      if (selectedImage) {
        uploadPromises.push(
          uploadMedia(selectedImage, "posts/images").then(
            (url) => (imageUrl = url)
          )
        );
      }

      if (selectedVideo) {
        uploadPromises.push(
          uploadMedia(selectedVideo, "posts/videos").then(
            (url) => (videoUrl = url)
          )
        );
      }

      await Promise.all(uploadPromises);

      await createPost(
        postContent,
        currentUserId,
        userName,
        imageUrl,
        videoUrl
      );

      // Clear form
      setPostContent("");
      setSelectedImage(null);
      setSelectedVideo(null);
      setSelectedDocument(null);
    } catch (error) {
      console.error("Error creating post:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  const handleVideoClick = () => {
    videoInputRef.current?.click();
  };

  // const handleDocumentClick = () => {
  // 	documentInputRef.current?.click();
  // };

  //            <h3> footprints announcement:</h3>
  //          <h5> Earn points towards conferences and publication fees by</h5>
  //          <div>
  //            <h5 style={{ display: "inline" }}>taking a</h5>
  //            <a
  //              style={{ display: "inline", marginLeft: 6, fontSize: 15 }}
  //              href="#"
  //            >
  //              <strong>survey,</strong>
  //            </a>
  //            <h5 style={{ display: "inline" }}> sharing data,</h5>
  //            <h5 style={{ display: "inline" }}>
  //              {" "}
  //              sharing knowledge scripts,{" "}
  //            </h5>
  //          </div>{" "}
  //          <h5> posting accademic blogs, and answering questions</h5>
  //         <br />

  return (
    <>
      <nav>
        <div className="show">
          <p>
            footprints - about us <br />
            <br />
            We are the researchers who care... <br />
            We care about sharing our knowledge, <br />
            our experience, and our data to enable <br />
            others to discover new knowledge and <br />
            leave their own footprints in the <br />
            sands of research.
          </p>
          <button className="closeButton" onClick={handleAboutClick}>
            {" "}
            Close
          </button>
        </div>
      </nav>

      <nav>
        <div style={{ marginTop: 30 }}>
          <div className="promote">
            <div>
              <h5 className="statistics" style={{ marginLeft: -3 }}>
                Countries
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfCountries}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Groups
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfGroups}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Projects
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfProjects}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Experiments
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfExperiments}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Users
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfUsers}
              />
            </div>
            <button
              style={{
                display: "inline-block",
                width: 60,
                height: 25,
                backgroundColor: "#1876f2",
                color: "white",
                borderRadius: 10,
                marginLeft: 0,
                cursor: "pointer",
              }}
              onClick={() => ShowClick()}
            >
              {showCountries}
            </button>
            <select
              name="Country List"
              id="country-list"
              style={{
                marginLeft: 70,
                marginTop: -20,
                width: 120,
                display: openCountriesList,
              }}
            >
              {uniqueCountries.map((uniqueCountries, key) => (
                <option key={key} value={uniqueCountries}>
                  {uniqueCountries}
                </option>
              ))}
            </select>
            <br />
            <div>
              <h3> footprints announcements:</h3>
              <br />
              <h4
                style={{
                  color: "blue",
                }}
              >
                {" "}
                {connectionMessage}
              </h4>
              <br />
            </div>
            <div>
              <div>
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "16px",
                    margin: "16px 0",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "20px",
                      marginBottom: "10px",
                      fontWeight: "500",
                      color: "#444",
                    }}
                  >
                    Share something...
                  </h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPostModal(true)}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#3b82f6",
                        backgroundImage: currentUser?.photoURL
                          ? `url(${currentUser?.photoURL})`
                          : "none",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                        position: "relative",
                      }}
                    >
                      {/* Semi-transparent overlay to ensure text visibility on any image */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.2)",
                          borderRadius: "50%",
                          display: currentUser?.photoURL ? "block" : "none",
                        }}
                      ></div>
                    </div>
                    <div
                      style={{
                        color: "#65676b",
                        fontSize: "17px",
                        backgroundColor: "rgb(228, 230, 233)",
                        borderRadius: 10,
                        padding: 10,
                        paddingLeft: 20,
                        paddingRight: 20,
                        width: "100%",
                      }}
                    >
                      Share your thoughts here and add optional items from
                      below...
                    </div>
                  </div>

                  {/* Action buttons row */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      marginTop: "16px",
                      paddingTop: "12px",
                      borderTop: "1px solid #e4e6eb",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#606770",
                        fontWeight: "500",
                        fontSize: "15px",
                        padding: "8px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        videoInputRef.current?.click();
                      }}
                    >
                      <img src={Video} width="18px" height="18px" alt=""></img>{" "}
                      Video
                    </button>

                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#606770",
                        fontWeight: "500",
                        fontSize: "15px",
                        padding: "8px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        imageInputRef.current?.click();
                      }}
                    >
                      <img src={Camera} width="18px" height="18px" alt=""></img>{" "}
                      Photos
                    </button>

                    {/* <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#606770',
                        fontWeight: '500',
                        fontSize: '15px',
                        padding: '8px',
                      }}
                      onClick={() => setShowPostModal(true)}
                    >
                      <img src={Events} width="18px" height="18px" alt=""></img>{' '}
                      Events
                    </button>

                    <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#606770',
                        fontWeight: '500',
                        fontSize: '15px',
                        padding: '8px',
                      }}
                      onClick={() => setShowPostModal(true)}
                    >
                      <img src={Links} width="18px" height="18px" alt=""></img>{' '}
                      Links
                    </button> */}

                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#606770",
                        fontWeight: "500",
                        fontSize: "15px",
                        padding: "8px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        documentInputRef.current?.click();
                      }}
                    >
                      <img
                        src={Documents}
                        width="18px"
                        height="18px"
                        alt=""
                      ></img>{" "}
                      Documents
                    </button>
                  </div>
                </div>

                {/* Keep existing input refs for file uploads */}
                <input
                  type="file"
                  ref={imageInputRef}
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files && setSelectedImage(e.target.files[0])
                  }
                />
                <input
                  type="file"
                  ref={videoInputRef}
                  style={{ display: "none" }}
                  accept="video/*"
                  onChange={(e) =>
                    e.target.files && setSelectedVideo(e.target.files[0])
                  }
                />
                <input
                  type="file"
                  ref={documentInputRef}
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                  onChange={(e) =>
                    e.target.files && setSelectedDocument(e.target.files[0])
                  }
                />

                {showPostModal && (
                  <CreatePostModal
                    onClose={() => setShowPostModal(false)}
                    currentUser={currentUser}
                    userId={currentUserId}
                  />
                )}
              </div>
              <PostList
                currentUserId={currentUserId}
                currentUsername={userName}
              />
            </div>
            <div>
              <h3> footprints promotion:</h3>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>SUNDANSE</h5>
              <a href="https://sundanseproject.eu/" target="_blank">
                <img src={Sundanse} style={{ marginTop: 20, width: 600 }}></img>
              </a>
              <br></br>
              <h5 style={{ marginLeft: 20 }}>POC4TRIAGE</h5>
              <a href="https://poc4triage.eu/" target="_blank">
                <img src={POC4} style={{ height: 200, width: 600 }}></img>
              </a>
              <br></br>
              <h5 style={{ marginLeft: 20 }}>ENOTTA</h5>
              <a href="https://enotta.eu/" target="_blank">
                <img src={ENOTTA} style={{ height: 200, width: 600 }}></img>
              </a>
            </div>
            <br></br>
            <br></br>
            <div>
              <h3> footprints endorsements:</h3>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>StartEngine</h5>
              <a href="https://www.startengine.com/" target="_blank">
                <img
                  src={StartEngine}
                  style={{ marginTop: 5, width: 600 }}
                ></img>
              </a>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>Starting Bloch</h5>
              <a href="http://www.startingbloch.com/en/" target="_blank">
                <img
                  src={StartingBloch}
                  style={{ marginTop: 5, width: 600 }}
                ></img>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Center;
